module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/clients"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" Back to Clients")]), _vm._v(" "), (_vm.$route.params.id != 'new') ? _c('nav-tabs', {
    attrs: {
      "classes": "pull-right",
      "tabs": _vm.navTabs
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('h2', {
    staticClass: "clickable-heading",
    attrs: {
      "title": _vm.detailsCollapsed ? 'Show details' : 'Collapse details'
    },
    on: {
      "click": _vm.collapseDetails
    }
  }, [(_vm.$root.mobile) ? _c('i', {
    staticClass: "fa",
    class: {
      'fa-caret-down': _vm.detailsCollapsed, 'fa-caret-up': !_vm.detailsCollapsed
    }
  }) : _vm._e(), _vm._v(" \n\t\t\t\t\t\t\tClient Details \n\t\t\t\t\t\t")]), _vm._v(" "), (_vm.detailsCollapsed) ? _c('p', {
    staticClass: "help-block",
    on: {
      "click": _vm.collapseDetails
    }
  }, [_vm._v("Click heading to expand details")]) : _vm._e(), _vm._v(" "), (!_vm.detailsCollapsed) ? _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveClientDetails($event)
      }
    }
  }, [_c('div', {
    staticClass: "client-detail-buttons"
  }, [(_vm.$route.params.id == 'new') ? _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (!_vm.$root.isOffline && !_vm.detailsCollapsed) ? _c('button', {
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]) : _vm._e()], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Company",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.company),
      expression: "client.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.company = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.company))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Contact Name",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.contact_name),
      expression: "client.contact_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.contact_name = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.contact_name))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Primary Phone",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.primary_phone),
      expression: "client.primary_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.client.primary_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.primary_phone = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.primary_phone))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Cell Phone",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.cellphone),
      expression: "client.cellphone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.client.cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.cellphone = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.cellphone))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Email",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.email),
      expression: "client.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.email = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.email))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Secondary Contact",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.secondary_contact),
      expression: "client.secondary_contact"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.client.secondary_contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.secondary_contact = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.secondary_contact))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Address",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.address),
      expression: "client.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.address = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.address))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "City",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.city),
      expression: "client.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.city = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.city))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Province",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.province),
      expression: "client.province"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.province)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.province = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.province))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Postal Code",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.postal_code),
      expression: "client.postal_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.postal_code = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.postal_code))])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Referred By",
      "col-class": "col-md-4"
    }
  }, [(!_vm.$root.isOffline) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.referred_by),
      expression: "client.referred_by"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.referred_by)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.referred_by = $event.target.value
      }
    }
  }) : _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.client.referred_by))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.alert.visible) ? _c('div', {
    staticClass: "alert",
    class: _vm.alert.class
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.clientDialog.alert.msg) + "\n\t\t\t\t\t\t\t"), _vm._l((_vm.alert.errors), function(error) {
    return (_vm.alert.hasErrors) ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(error) + "\n\t\t\t\t\t\t\t")]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.$route.params.id != 'new' && !_vm.detailsCollapsed) ? _c('button', {
    staticClass: "btn btn-danger block-button",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": _vm.deleteClient
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Delete Client")]) : _vm._e()]), _vm._v(" "), (_vm.activeTab == 'tasks') ? _c('div', {
    staticClass: "well"
  }, [_c('h3', [_vm._v("Filter Tasks")]), _vm._v(" "), _c('button-group', {
    attrs: {
      "vertical": "true",
      "buttons": _vm.taskFilter.buttons,
      "full-width": true
    },
    model: {
      value: (_vm.taskFilter.value),
      callback: function($$v) {
        _vm.taskFilter.value = $$v
      },
      expression: "taskFilter.value"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [(_vm.activeTab == 'locations') ? _c('div', [_c('h2', [_vm._v("Locations")]), _vm._v(" "), (!_vm.$root.isOffline) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.newLocation
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New Location")]) : _vm._e(), _vm._v(" "), _c('search-widget', {
    on: {
      "submit": _vm.filterLocations
    },
    model: {
      value: (_vm.locationFilterTerms),
      callback: function($$v) {
        _vm.locationFilterTerms = $$v
      },
      expression: "locationFilterTerms"
    }
  }), _vm._v(" "), _c('table-list', {
    attrs: {
      "records": _vm.locations,
      "fields": _vm.locationFields,
      "has-edit": true,
      "delete-endpoint": "location/delete",
      "has-delete": true
    },
    on: {
      "modelChange": _vm.filterLocations,
      "edit": _vm.editLocation
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'audits') ? _c('div', [_c('h2', [_vm._v("Audits")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.newAudit
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New Audit")]), _vm._v(" "), _c('search-widget', {
    on: {
      "submit": _vm.filterAudits
    },
    model: {
      value: (_vm.auditFilterTerms),
      callback: function($$v) {
        _vm.auditFilterTerms = $$v
      },
      expression: "auditFilterTerms"
    }
  }), _vm._v(" "), _c('table-list', {
    attrs: {
      "records": _vm.audits,
      "fields": _vm.auditFields,
      "has-edit": "/audits/form/",
      "has-delete": true,
      "delete-endpoint": "auditForm/delete"
    },
    on: {
      "modelChange": _vm.filterAudits
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'reports') ? _c('div', [(!_vm.$root.isOffline) ? _c('div', [_c('h2', [_vm._v("Reports")]), _vm._v(" "), (!_vm.$root.isOffline) ? _c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "/reports/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New Report")]) : _vm._e(), _vm._v(" "), _c('table-list', {
    attrs: {
      "records": _vm.amendedReports,
      "fields": _vm.reportFields,
      "has-edit": "/reports/edit/",
      "has-delete": true,
      "delete-endpoint": "/report/delete"
    },
    on: {
      "modelChange": _vm.filterReports
    }
  })], 1) : _c('page-offline-alert')], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'tasks') ? _c('div', [(!_vm.$root.isOffline) ? _c('div', [_c('task-list', {
    attrs: {
      "editable": true,
      "heading": _vm.taskFilter.value + ' Tasks',
      "include-new-button": true,
      "owner-type": "client",
      "tasks": _vm.filteredTasks
    },
    on: {
      "modelChanged": _vm.fetchTasks
    }
  })], 1) : _c('page-offline-alert')], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'phases') ? _c('div', [(!_vm.$root.isOffline) ? _c('div', [_c('phase-list', {
    attrs: {
      "phases": _vm.clientPhases,
      "editable": true,
      "owner-type": "client"
    },
    on: {
      "phasesChanged": _vm.fetchPhases
    }
  })], 1) : _c('page-offline-alert')], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'expenses') ? _c('div', [(!_vm.$root.isOffline) ? _c('div', [_c('h2', [_vm._v("Client Expenses for " + _vm._s(_vm.$root.userFullName))]), _vm._v(" "), _c('expense-list', {
    attrs: {
      "owner-type": "client",
      "locations": _vm.locations
    }
  })], 1) : _c('page-offline-alert')], 1) : _vm._e()])])])]), _vm._v(" "), (_vm.locationDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.locationDialog.title,
      "modal-visible": _vm.locationDialog.visible,
      "confirm-button-text": _vm.locationDialog.buttonText,
      "button-class": _vm.locationDialog.buttonClass
    },
    on: {
      "confirm": function($event) {
        _vm.saveLocationEdit(_vm.locationDialog.fields)
      },
      "closeModal": function($event) {
        _vm.locationDialog.visible = false
      }
    }
  }, _vm._l((_vm.locationFields), function(field) {
    return _c('form-group', {
      key: field.key,
      attrs: {
        "label": field.label,
        "col-class": "col-md-4"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.locationDialog.fields[field.key]),
        expression: "locationDialog.fields[field.key]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.locationDialog.fields[field.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.locationDialog.fields, field.key, $event.target.value)
        }
      }
    })])
  })) : _vm._e(), _vm._v(" "), (_vm.auditDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.auditDialog.title,
      "modal-visible": _vm.auditDialog.visible,
      "confirm-button-text": _vm.auditDialog.buttonText,
      "button-class": _vm.auditDialog.buttonClass
    },
    on: {
      "confirm": _vm.createNewAudit,
      "closeModal": function($event) {
        _vm.auditDialog.visible = false
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Location",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auditDialog.fields.location_id),
      expression: "auditDialog.fields.location_id"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.auditDialog.fields.location_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.locations), function(location) {
    return _c('option', {
      domProps: {
        "value": location.id
      }
    }, [_vm._v(_vm._s(location.location_name))])
  }))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Audit Date",
      "col-class": "col-md-4"
    }
  }, [_c('date-field', {
    attrs: {
      "extra-classes": "form-control"
    },
    model: {
      value: (_vm.auditDialog.fields.audit_date),
      callback: function($$v) {
        _vm.auditDialog.fields.audit_date = $$v
      },
      expression: "auditDialog.fields.audit_date"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Form Template",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auditDialog.fields.form_template_id),
      expression: "auditDialog.fields.form_template_id"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.auditDialog.fields.form_template_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.auditTemplates), function(template) {
    return _c('option', {
      domProps: {
        "value": template.id
      }
    }, [_vm._v(_vm._s(template.form_name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-4 checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auditDialog.generateTask),
      expression: "auditDialog.generateTask"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.auditDialog.generateTask) ? _vm._i(_vm.auditDialog.generateTask, null) > -1 : (_vm.auditDialog.generateTask)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.auditDialog.generateTask,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.auditDialog.generateTask = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.auditDialog.generateTask = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.auditDialog.generateTask = $$c
        }
      }
    }
  }), _vm._v("\n            \t\tGenerate a task that is linked to this Audit\n            \t")])])], 1) : _vm._e(), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.confirmDialog.title,
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": _vm.confirmDialog.buttonText,
      "button-class": _vm.confirmDialog.buttonClass
    },
    on: {
      "confirm": function($event) {
        _vm.executeDelete(_vm.confirmDialog.parameters)
      },
      "closeModal": function($event) {
        _vm.confirmDialog.visible = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.confirmDialog.message) + "\n        ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-103f1c7d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ClientEditor.vue
// module id = 265
// module chunks = 0